import React, { createContext, useCallback, useContext, useMemo } from "react";
import { useSyncExternalStore } from "react";
import {
  getCurrentLocale,
  subscribe,
  setLocale as setStoreLocale,
} from "../utlis/locale";

const I18nContext = createContext(null);

// Subscribes the tree to the reactive locale store so a language change
// re-renders every consumer. Mount once at the app root.
const I18nProvider = ({ children }) => {
  const locale = useSyncExternalStore(subscribe, getCurrentLocale);

  const setLocale = useCallback((next) => setStoreLocale(next), []);

  const value = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

// Returns { locale, setLocale }. Prefer this for the language switcher.
const useLocale = () => {
  const ctx = useContext(I18nContext);
  if (ctx) return ctx;
  // Fallback so hooks work even if a component renders outside the provider.
  return { locale: getCurrentLocale(), setLocale: setStoreLocale };
};

export { I18nProvider, useLocale, I18nContext };
export default I18nProvider;
